"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_pay_fee_controller_1 = __importDefault(require("./student-pay-fee.controller"));
var student_pay_fee_html_1 = __importDefault(require("./student-pay-fee.html"));
function getFee($stateParams, FeeModel) {
    return FeeModel.getFee($stateParams.feeId)
        .then(function (response) {
        return response.fee;
    })
        .catch(function (Error) {
        console.error(Error);
    });
}
getFee.$inject = ["$stateParams", "FeeModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.fees.pay", {
        url: "/:feeId/pay-fee",
        controller: student_pay_fee_controller_1.default,
        controllerAs: "vm",
        template: student_pay_fee_html_1.default,
        resolve: {
            fee: getFee,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.fees.pay", [])
    .config(config)
    .controller("StudentFeesPayController", student_pay_fee_controller_1.default);
